import styled from 'styled-components';

interface titleHeaderProps {
	margin?: string;
	padding?: string;
	marginTop?: string;
	marginBottom?: string;
	paddingTop?: string;
	paddingBottom?: string;
	flexDirectionColumn?: boolean;
	alignItemsStart?: boolean;
}

const TitleHeader = styled.div<titleHeaderProps>`
	padding-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: ${({ margin }) => margin}!important;
	padding: ${({ padding }) => padding}!important;
	margin-top: ${({ marginTop }) => marginTop}!important;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	padding-top: ${({ paddingTop }) => paddingTop}!important;
	padding-bottom: ${({ paddingBottom }) => paddingBottom}!important;

	${({ flexDirectionColumn }) =>
		flexDirectionColumn &&
		`flex-direction: column;
    `}
	${({ alignItemsStart }) =>
		alignItemsStart &&
		`align-items: flex-start;
	`}
`;

export default TitleHeader;
